import { useContext } from 'react';
import MessageContext from '../../contexts/MessageContext';

const useMessageContext = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessageContext must be used within MessageContextProvider!');
  }
  return context;
};

export default useMessageContext;
